import styled, { keyframes } from 'styled-components';

export const ScSecondStageOffer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 40px;
  width: 100%;
`;

export const ScOfferPrizes = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  text-align: center;
  text-transform: uppercase;
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const ScOfferPlusReveal = styled.div`
  animation: ${fadeIn} 1600ms ease-out 400ms both;
   > p {
    line-height: 70px;
   }
`;

export const ScOfferSecondPrizeReveal = styled.div`
  width: 100%;
  animation: ${fadeIn} 600ms ease-out 1200ms both;
`;

export const ScOfferPrizeLabel = styled.p`
  margin: 0;
  width: 100%;
  font-family: inherit;
  font-weight: 700;
  font-size: 20px;
  letter-spacing: 1px;
  line-height: 38px;
  color: ${({ theme }) => theme.whiteColor};
`;

// a05a05
export const ScOfferPrizeAmount = styled.p`
  position: relative;
  margin: 0;
  width: 100%;
  text-align: center;
  font-family: 'Work Sans';
  font-size: 60px;
  font-style: normal;
  font-weight: 800;
  line-height: 50px;
  letter-spacing: 1.8px;

  &::before {
    content: attr(data-text);
    position: absolute;
    inset: 0;
    z-index: -1;
    color: #a05a05;
    text-shadow: 1px 2px 0 #a05a05;
  }

  background: linear-gradient(
    180deg,
    #fedf79 0%,
    #fcd25d 35.78%,
    #e7a32e 50.63%,
    #cd7e1b 83.42%,
    #f7c54b 108.08%
  );

  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;
